import { render, staticRenderFns } from "./huoDongTuiSong.vue?vue&type=template&id=f04fec02&scoped=true&"
import script from "./huoDongTuiSong.vue?vue&type=script&lang=js&"
export * from "./huoDongTuiSong.vue?vue&type=script&lang=js&"
import style0 from "./huoDongTuiSong.vue?vue&type=style&index=0&id=f04fec02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04fec02",
  null
  
)

export default component.exports